import {useState} from 'react';
import {FeedbackDialog} from './feedback-dialog';
import {IconButton} from '@ui/buttons/icon-button';
import {MessageIcon} from '@ui/icons/material/Message';
import {Tooltip} from '@ui/tooltip/tooltip';
import {Trans} from '@ui/i18n/trans';

export function FeedbackButton() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Tooltip label={<Trans message="Send Feedback" />}>
        <IconButton
          size="lg"
          color="primary"
          variant="flat"
          data-tour="feedback-button"
          className="fixed bottom-[100px] right-[280px] z-50 shadow-lg hover:shadow-xl transition-shadow"
          onClick={() => setIsDialogOpen(true)}
          aria-label="Send feedback"
        >
          <MessageIcon />
        </IconButton>
      </Tooltip>

      <FeedbackDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
